import {commitMutation, Disposable, Environment, graphql} from 'react-relay';

import Util from '../../forecast-app/shared/util/util';
import {StoreCustomMetricInput, StoreCustomMetricMutation} from './__generated__/StoreCustomMetricMutation.graphql';
import {MutationInput, RelayOnCompleted, RelayOnError} from './MutationTypes';

const mutation = graphql`
	mutation StoreCustomMetricMutation($input: StoreCustomMetricInput!) {
		storeCustomMetric(input: $input) {
			clientMutationId
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<StoreCustomMetricInput>,
	onSuccess: RelayOnCompleted<StoreCustomMetricMutation>,
	onError: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
